import { ApiClient } from './';
import { FilePreviewFormatType, FilePreviewSizeType, UploadFileResponse } from 'src/api/api-types/files';

export class FilesApi extends ApiClient {
  getFilesUrl(key: number | string, abortController?: AbortController) {
    return this.requestFiles<Blob>(`files/${key}`, undefined, abortController);
  }

  getFilesUrlByToken(token?: string, abortController?: AbortController) {
    return this.requestFiles<Blob>(`files`, { token }, abortController);
  }

  getDownloadUrlByToken(token: string): string {
    return `${this.env.__fileApi}/v1/files?token=${token}`;
  }

  getFilePreview(
    token: string,
    format: FilePreviewFormatType = 'jpg',
    size: FilePreviewSizeType | undefined = undefined,
    abortController?: AbortController
  ) {
    const params: { token: string;  format: string; size?: number } = {
      token,
      format,
    };
    if (size !== undefined) {
      params.size = size;
    }

    return this.requestFiles<Blob>(`files/preview`, params, abortController, {
      withCredentials: true,
    });
  }

  deleteFile(key: number | string) {
    return this.requestDelete<UploadFileResponse>(`files/${key}`);
  }
  deleteFileFromService(key: number | string) {
    return this.requestFilesDelete<UploadFileResponse>(`files/${key}`);
  }

  uploadFile<P>(
    url: string,
    file: File,
    params?: P,
    progressCallback?: (progress: number) => void,
  ) {
    return this.requestUploadFile<UploadFileResponse, P>(
      url,
      file,
      params,
      progressCallback,
    );
  }
}
